module.exports = __webpack_public_path__ + "static/media/Spanish_European_Lucia BG-51.623fd7b3.png";